<script lang="ts" setup>
const { t } = useI18n();

interface Props {
  showConfirm?: boolean;
  isDialogVisible: boolean;
  title: string;
  description: string;
  info?: string;
  disabledConfirm?: boolean;
  okLabel?: string;
  cancelLabel?: string;
  icon?: string | object;
  iconColorTheme?: "success" | "warning" | "error";
  colorTheme?: "primary" | "danger";
}

withDefaults(defineProps<Props>(), {
  showConfirm: true,
  info: undefined,
  okLabel: undefined,
  cancelLabel: undefined,
  icon: undefined,
  iconColorTheme: undefined,
  colorTheme: undefined,
});

defineEmits(["confirm", "cancel"]);
</script>

<template>
  <lxc-confirm
    :show="isDialogVisible"
    :title="title"
    :message="description"
    :ok-label="okLabel ?? t('button.confirm')"
    :cancel-label="cancelLabel ?? t('button.cancel')"
    :disable-confirm-button="disabledConfirm"
    :show-confirm-button="showConfirm"
    :icon="icon"
    :icon-color-theme="iconColorTheme"
    :color-theme="colorTheme"
    @confirm="$emit('confirm')"
    @cancel="$emit('cancel', false)"
  >
    <span>{{ description }}</span>
    <information-row v-if="info" :title="info" />
  </lxc-confirm>
</template>
